/**
 * Labstep
 *
 * @module screens/ResourceLocation/Index
 * @desc ResourceLocation manager page
 */

import EntitySearch from 'labstep-web/components/Entity/Search';
import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { ResourceLocationActionCreate } from 'labstep-web/components/ResourceLocation/Action/Create';
import { Action } from 'labstep-web/components/ResourceLocation/Action/Menu';
import { ResourceLocationEmptyState } from 'labstep-web/components/ResourceLocation/EmptyState';
import { ResourceLocationTable } from 'labstep-web/components/ResourceLocation/Table';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import type React from 'react';
import { useMemo } from 'react';
import { filters } from './constants';
import type { IScreensResourceLocationIndexProps } from './types';

export const ScreensResourceLocationIndex: React.FC<
  IScreensResourceLocationIndexProps
> = ({ group }) => {
  const params = useMemo(() => ({ group_id: group.id }), [group.id]);
  const action = useMemo(() => <ResourceLocationActionCreate />, []);
  const noResultsMessage = useMemo(
    () => <ResourceLocationEmptyState />,
    [],
  );
  return (
    <EntitySearch
      params={params}
      entityName={ResourceLocation.entityName}
      action={action}
      noResultsMessage={noResultsMessage}
      filters={filters}
      tableFormat
      bulkActions={[BulkAction.delete, BulkAction.assign]}
    >
      {({ entities, ...rest }): React.ReactElement => (
        <ResourceLocationTable
          actions={[
            Action.delete,
            Action.update_outer,
            Action.assign,
          ]}
          resourceLocations={entities}
          showCollaborators
          {...rest}
        />
      )}
    </EntitySearch>
  );
};
